import { useNavigate } from 'react-router-dom';
import './create-news.css';
import CloseButton from '../../components/CloseButton';
import { useState } from 'react';
import Input from '../../components/Input';
import { create, post } from '../../services/api';
import { useUI } from '../../UIContext';
import { handleErr } from '../../utils/functions';
import PhotoInput from '../../components/PhotoInput';
import TextArea from '../../components/TextArea';

function CreateNews() {
    const navigate = useNavigate();

    const { setLoading, setMessage } = useUI();
    const [image, setImage] = useState(undefined);
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [submitAttempt, setSubmitAttempt] = useState(false);
    const [hasSavedProcess, setHasSavedProcess] = useState(false);

    function isTitleValid() {
        return !!title && title.length >= 2 && title.length <= 56;
    }

    function isDescriptionValid() {
        return !!description && description.length >= 2 && description.length <= 200;
    }

    function clearScreen() {
        setSubmitAttempt(false);
        setImage(undefined);
        setTitle('');
        setDescription('');
    }

    async function onClickSave(e) {
        function isSaveValid() {
            setSubmitAttempt(true);

            return !!title && !!description;
        }

        function showSuccess() {
            setHasSavedProcess(true);
            setMessage({ type: 'success', text: 'A notícia foi cadastrada.' });
        }

        e.preventDefault();

        if (!isSaveValid())
            return;

        setLoading(true);

        const data = {
            title,
            description
        };

        await create('news', data, true, setMessage,
            async (response) => {
                clearScreen();
                
                if (!image) {
                    showSuccess();
                    return;
                }

                const formData = new FormData();
                formData.append('image', image);
                await post(`news/${response.data.id}/image`, formData, true, setMessage,
                    () => {
                        showSuccess();
                    },
                    (err) => {
                        handleErr(setMessage, `Não foi possível salvar a image da notícia: ${err}`);
                    },
                    () => {
                        setLoading(false);
                    }
                )
            },
            (err) => {
                handleErr(setMessage, `Não foi possível cadastrar a notícia: ${err}`);
            },
            () => {
                if (!image)
                    setLoading(false);
            }
        );
    }

    return (
        <form className='default-form'>
            <header className='container-header'>
                <h1>Nova Notícia</h1>

                <CloseButton
                    onClick={() => navigate('/news')}
                    shouldConfirm={!hasSavedProcess}
                />
            </header>

            <div className='news-image-container'>
                <PhotoInput
                    photo={image}
                    onChange={(file) => setImage(file)}
                    onRemove={() => setImage(undefined)}
                />
            </div>

            <Input
                className='commom-input glass-effect-15'
                type='text'
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                onValidate={isTitleValid}
                placeholder='Título'
                shouldValidate={submitAttempt}
                maxLength={100}
                warningMsg='O título deve conter ao menos 3 caracteres.'
            />
            
            <TextArea
                cols='4'
                rows='4'
                className='commom-input glass-effect-15'
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                onValidate={isDescriptionValid}
                placeholder='Descrição'
                shouldValidate={submitAttempt}
                maxLength={20000}
                warningMsg='A descrição deve conter ao menos 5 caracteres.'
            />

            <div className='container-save-form'>
                <button
                    type='submit'
                    onClick={onClickSave}
                    className='blue-button zoom-effect'>
                    Salvar
                </button>
            </div>
        </form>
    );
}

export default CreateNews;